import * as React from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { getChemicalProduct } from '../../../actions/ChemicalActions';
import { TChemicalState } from '../../../types/Chemical';
import { IAppState } from '../../../store/Store';
import { setCurrentPageTitle } from '../../../actions/ContentActions';
import ChemicalProduct from '../../../components/chemicals/ChemicalProduct';
import { useTranslation } from 'react-i18next';

const ChemicalProductPage: React.FC<
  RouteComponentProps<{
    productId?: string;
  }>
> = ({
  match: {
    params: { productId },
  },
}): JSX.Element => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const chemicalsState: TChemicalState = useSelector<IAppState, TChemicalState>(
    (state) => state.chemicalState
  );

  useEffect(() => {
    dispatch(getChemicalProduct(parseInt(productId as string)));
  }, [dispatch, productId]);

  useEffect(() => {
    dispatch(
      setCurrentPageTitle(t('page.title.chemical'))
    );
  }, [t, dispatch]);

  const [expandedFirstAid, setExpandedFirstAid] = useState(
    !!localStorage.getItem('expandedFirstAid')
  );

  const [expandedHazards, setExpandedHazards] = useState(
    !!localStorage.getItem('expandedHazards')
  );

  const [expandedProducer, setExpandedProducer] = useState(
    !!localStorage.getItem('expandedProducer')
  );

  const [expandedHandling, setExpandedHandling] = useState(
    !!localStorage.getItem('expandedHandling')
  );

  const [expandedExposure, setExpandedExposure] = useState(
    !!localStorage.getItem('expandedExposure')
  );

  const [expandedFireFighting, setExpandedFireFighting] = useState(
    !!localStorage.getItem('expandedFireFighting')
  );

  const [expandedSpills, setExpandedSpills] = useState(
    !!localStorage.getItem('expandedSpills')
  );

  const [expandedEmergency, setExpandedEmergency] = useState(
    !!localStorage.getItem('expandedEmergency')
  );

  const [expandedProcess, setExpandedProcess] = useState(
    !!localStorage.getItem('expandedProcess')
  );

  const updateLocalStorage = (title: string, isExpanded: boolean) => {
    if (isExpanded) {
      localStorage.setItem(title, String(isExpanded));
    } else {
      localStorage.removeItem(title);
    }
  }

  const handleChange =
    (panel: string) => (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
      switch (panel) {
        case 'panel2':
          setExpandedFirstAid(isExpanded);
          updateLocalStorage('expandedFirstAid', isExpanded);
          break;
        case 'panel3':
          setExpandedHazards(isExpanded);
          updateLocalStorage('expandedHazards', isExpanded);
          break;
        case 'panel4':
          setExpandedProducer(isExpanded);
          updateLocalStorage('expandedProducer', isExpanded);
          break;
        case 'panel5':
          setExpandedHandling(isExpanded);
          updateLocalStorage('expandedHandling', isExpanded);
          break;
        case 'panel7':
          setExpandedExposure(isExpanded);
          updateLocalStorage('expandedExposure', isExpanded);
          break;
        case 'panel8':
          setExpandedFireFighting(isExpanded);
          updateLocalStorage('expandedFireFighting', isExpanded);
          break;
        case 'panel9':
          setExpandedSpills(isExpanded);
          updateLocalStorage('expandedSpills', isExpanded);
          break;
        case 'panel10':
          setExpandedEmergency(isExpanded);
          updateLocalStorage('expandedEmergency', isExpanded);
          break;
        case 'panel11':
          setExpandedProcess(isExpanded);
          updateLocalStorage('expandedProcess', isExpanded);
      }
    };

  return (
    <>
      {chemicalsState.activeChemical && !chemicalsState.loading && (
        <ChemicalProduct
          chemical={chemicalsState}
          expandedFirstAid={expandedFirstAid}
          expandedHazards={expandedHazards}
          expandedProducer={expandedProducer}
          expandedHandling={expandedHandling}
          expandedExposure={expandedExposure}
          expandedFireFighting={expandedFireFighting}
          expandedSpills={expandedSpills}
          expandedEmergency={expandedEmergency}
          expandedProcess={expandedProcess}
          handleChange={handleChange}
        />
      )}
    </>
  );
};

export default withRouter(ChemicalProductPage);
